<ag-grid-angular
  #grid
  class="grid ag-theme-material cell-borders no-min-height"
  [rowData]="rowData()"
  (rowDragEnd)="onRowDragEnd($event)"
  (rowDragEnter)="onRowDragEnter($event)"
  [columnDefs]="columnDefs"
  (gridReady)="onGridReady($event)"
  [gridOptions]="gridOptions"
  [style.height]="hasMultipleAreas() ? '617px' : '665px'"
></ag-grid-angular>

@if (rowData().length === 1 && !hasMultipleAreas()) {
  <div class="radius-container">
    @if (this.getRadiusForm()?.value) {
      <div class="container-flex">
        <app-button (pressed)="openEditAreaDialog()" type="ghost">
          <mat-icon icon-right icon-medium-16 class="filled-icon">edit</mat-icon>
          {{ translations.areaHa }}: {{ radiusArea() | number }}
        </app-button>
      </div>
    } @else {
      <app-button type="ghost" (pressed)="openEditAreaDialog()">
        <ng-container i18n="@@coordinates.addareasize">Add area size</ng-container>
      </app-button>
    }
  </div>
}
